import { useEffect, useRef } from "react";

/**
 * Adds the `in-view` class to elements with `.reveal` once they intersect
 * the viewport. One-shot (does not toggle back off).
 */
export default function useReveal(rootRef, options = {}) {
  const observerRef = useRef(null);

  useEffect(() => {
    const root = rootRef?.current ?? document;
    const targets = root.querySelectorAll(".reveal");
    if (!targets.length) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observerRef.current.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px -10% 0px",
        threshold: 0.12,
        ...options,
      }
    );

    targets.forEach((t) => observerRef.current.observe(t));

    return () => observerRef.current?.disconnect();
  }, [rootRef, options]);
}
